import { MbusinessStatus } from 'models/mbusiness'

export const MBUSINESS_STATUS_TEXT: Record<MbusinessStatus, string> = {
  [MbusinessStatus.in_process]: 'В очереди',
  [MbusinessStatus.waiting]: 'В работе',
  [MbusinessStatus.error]: 'На уточнении',
  [MbusinessStatus.denied]: 'Отклонено',
  [MbusinessStatus.given]: 'Закрыто',
  [MbusinessStatus.notfound]: 'Не найден',
  [MbusinessStatus.failed]: 'Ошибка',
}
